
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CreatePackageForm } from "@/components/package/CreatePackageForm";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { supabase } from "@/lib/supabase";
import { toast } from "sonner";

const CreatePackage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        toast.error("Please sign in to create a package");
        navigate("/login");
      }
    };

    checkAuth();
  }, [navigate]);

  return (
    <>
      <Header />
      <div className="container max-w-2xl mx-auto py-8 px-4">
        <h1 className="text-3xl font-bold mb-8">Create New Package</h1>
        <CreatePackageForm />
      </div>
      <Footer />
    </>
  );
};

export default CreatePackage;
